import { UNLIMITED_TIER } from "@chesshotel/constants";
import useTranslation from "next-translate/useTranslation";
import { FaInfinity } from "react-icons/fa";
import { useMembership } from "../../redux/membership";
import { useUser } from "../../redux/user";

export default function MembershipInfo() {
  const { t } = useTranslation("common");
  const { leagueGames, tier, gameReviews } = useMembership();
  const { memberLoggedIn } = useUser();

  if (!memberLoggedIn) return null;

  return (
    <dl className="hidden flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-600 md:flex md:justify-end md:text-sm">
      {[
        {
          label: t("League games"),
          value: leagueGames,
          unlimited: t("Unlimited league games"),
        },
        {
          label: t("Game Reviews"),
          value: gameReviews,
          unlimited: t("Unlimited game analysis"),
        },
      ].map(({ label, value, unlimited }) => (
        <div key={label} className="flex items-center gap-1.5">
          <dt>{label}</dt>
          <dd className="font-semibold tabular-nums text-gray-800">
            {tier === UNLIMITED_TIER ? (
              <span aria-label={unlimited}>
                <FaInfinity aria-hidden="true" />
              </span>
            ) : (
              value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
